const DESKTOP_MEDIA_QUERY = window.matchMedia('(min-width: 1240px)');

export function desktopMediaQuery(): MediaQueryList {
    return DESKTOP_MEDIA_QUERY;
}
